export enum TextAlignments {
    LEFT = "left",
    RIGHT = "right",
    CENTRE = "center",
    JUSTIFIED = "justify",
}
